import { ObservableFromFetch } from "../ObservableFromFetch"
import OrderSecurityOverrideRecord from "./Model/OrderSecurityOverrideRecord"

export default function OrderSecurityOverrideUpdateObservable(roleID: number, userID: string, orderSecurityException: OrderSecurityOverrideRecord[]) {
  const requestBody: string = JSON.stringify({
    RoleID: roleID,
    MockApplicationUserIDFrom: userID,
    ModifiedBy: "", // Kyle: MCP only and does not need to be considered
    OrderSecurityException: orderSecurityException
  })

  return ObservableFromFetch<string>("FFOrderRoleOrderSecurity/SaveOrderSecurityException", requestBody)
}
